import React, { useEffect } from "react";
import "../../styles/home/TrustSection.css";
import manceImg from "../../assets/mance-logo-mg.png";
import zojapayImg from "../../assets/zojapay-logo-mg.png";
// import ubaImg from "../../assets/uba-img.png";
// import nnpcImg from "../../assets/nnpc-img.png";
// import zohoImg from "../../assets/zoho-img.png";
import swapImg from "../../assets/swap-logo-mg.png";
import Aos from "aos";
import "aos/dist/aos.css";

const TrustSection = () => {
  const swapIcon = (
    <svg
      width="91"
      height="29"
      viewBox="0 0 91 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="img"
    >
      <g clipPath="url(#clip0_31173_33845)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.6289 10.3007L53.7377 11.796L47.9032 13.0644L49.0187 7.30704L50.7448 8.40775C51.2544 7.92196 51.7268 7.35306 52.254 6.8977C52.5323 6.65678 52.8951 6.22744 53.0055 5.86991C53.4122 4.55036 52.4465 3.30409 51.0533 3.46695C50.3297 3.55165 49.9966 3.98576 49.4978 4.44235C48.9803 4.91599 48.5024 5.431 48.006 5.91679L45.0258 8.90127C44.1216 9.80669 42.7952 11.3014 41.6497 11.8207C40.7471 12.2299 39.6435 12.3234 38.6744 12.1216C37.7899 11.9374 37.0018 11.4759 36.3967 10.8066C34.8103 9.05236 34.8467 6.45082 36.3826 4.67678L38.2107 2.83363L36.7417 1.28605L42.9748 0L41.8679 5.91336L40.1274 4.73741C40.0115 4.85414 39.8983 4.97441 39.8068 5.06709C39.5594 5.31759 39.3171 5.57644 39.0681 5.82462C38.5958 6.29483 38.1514 6.63444 37.9756 7.31698C37.8336 7.86783 38.0506 8.61456 38.4716 8.99898C38.7061 9.21303 38.8581 9.33012 39.1726 9.42474C40.3265 9.77209 40.9208 9.13926 41.6808 8.38947L47.7062 2.44455C48.0026 2.15231 48.2092 1.9239 48.547 1.66358C49.6864 0.785758 51.2338 0.520521 52.6117 0.911438C53.2365 1.0888 53.7423 1.39233 54.2542 1.77932C55.0738 2.39889 55.6038 3.63547 55.7402 4.63836C55.9977 6.53575 55.0066 7.9541 53.7611 9.22505C53.5364 9.47212 53.2649 9.7122 53.0208 9.94073C52.9161 10.0388 52.7675 10.1694 52.6289 10.3007V10.3007Z"
          fill="#71458F"
        />
        <path
          d="M5.69326 28.3885C8.82909 28.3885 10.677 26.7645 10.677 24.3193C10.677 21.9488 8.84776 21.1275 6.08523 20.5116C4.10668 20.0636 3.34139 19.7649 3.34139 18.8317C3.34139 18.0664 4.05068 17.4504 5.22662 17.4504C6.45854 17.4504 7.74649 17.9543 8.88509 18.869L10.3223 16.8904C9.01574 15.7705 7.39182 15.1172 5.3013 15.1172C2.50144 15.1172 0.560218 16.7411 0.560218 19.1116C0.560218 21.5942 2.48276 22.3595 5.18929 22.9754C7.14916 23.4234 7.8958 23.7034 7.8958 24.618C7.8958 25.4206 7.1865 26.0552 5.80524 26.0552C4.18133 26.0552 2.8001 25.4206 1.58683 24.3753L0.000244141 26.2605C1.49348 27.6418 3.47206 28.3884 5.69327 28.3884L5.69326 28.3885Z"
          fill="#71458F"
        />
        <path
          d="M23.1111 18.291C21.6738 18.291 20.4792 18.9816 19.9752 20.0456C19.3779 18.963 18.2393 18.291 16.914 18.291C15.7195 18.291 14.7675 18.8696 14.3009 19.7843V18.515H11.5757V28.1651H14.3009V22.3415C14.3009 21.3148 15.0661 20.5869 16.1674 20.5869C17.1567 20.5869 17.866 21.3708 17.866 22.4908V28.1838H20.4792V22.3415C20.4792 21.3148 21.2632 20.5869 22.3458 20.5869C23.3537 20.5869 24.063 21.3708 24.063 22.4908V28.1838H26.6762V22.0241C26.6762 19.8402 25.1269 18.291 23.1111 18.291L23.1111 18.291Z"
          fill="#71458F"
        />
        <path
          d="M32.4389 18.291C31.0949 18.291 29.7697 18.6643 28.4071 19.3549L29.3217 21.1655C30.087 20.7735 30.9269 20.4749 31.8229 20.4749C33.4095 20.4749 34.0441 21.3708 34.0441 22.3975V22.5841C33.2228 22.2668 32.3642 22.0988 31.5802 22.0988C29.3404 22.0988 27.5671 23.4054 27.5671 25.3093C27.5671 27.1572 29.1537 28.3891 31.2069 28.3891C32.2522 28.3891 33.3535 27.9785 34.0441 27.1945V28.1651H36.676V22.3975C36.676 19.8776 34.9587 18.291 32.4389 18.291V18.291ZM31.8229 26.5039C30.8896 26.5039 30.199 26.0186 30.199 25.2346C30.199 24.4507 30.9829 23.872 31.9722 23.872C32.7188 23.872 33.4281 24.0027 34.0441 24.2267V25.1226C33.8575 26.0186 32.8682 26.5039 31.8229 26.5039Z"
          fill="#71458F"
        />
        <path
          d="M40.295 20.3069V18.515H37.5698V28.1651H40.295V23.5547C40.295 21.7442 41.5829 20.5869 43.5988 20.5869V18.291C42.1242 18.291 40.9296 19.0563 40.295 20.3069V20.3069Z"
          fill="#71458F"
        />
        <path
          d="M50.2751 25.7747C50.0884 25.9614 49.7151 26.092 49.3418 26.092C48.8378 26.092 48.4272 25.6441 48.4272 25.0094V20.7163H50.5177V18.5138H48.4272V15.8633H45.814V18.5138H44.4888V20.7163H45.814V25.4387C45.814 27.1746 47.0086 28.3879 48.7072 28.3879C49.4912 28.3879 50.3684 28.0519 50.9284 27.548L50.2751 25.7747Z"
          fill="#71458F"
        />
        <path
          d="M56.9017 28.3885C59.8882 28.3885 61.4188 26.7272 61.4188 24.6927C61.4188 22.4341 59.6642 21.5568 57.219 20.9782C55.0351 20.4555 53.7659 19.9889 53.7659 18.6636C53.7659 17.4877 54.9231 16.4424 56.5097 16.4424C57.8536 16.4424 59.1229 17.0584 60.1868 18.085L61.0828 16.9464C59.9068 15.8638 58.4883 15.1172 56.5843 15.1172C54.1205 15.1172 52.2912 16.7224 52.2912 18.7757C52.2912 20.9969 53.9152 21.7995 56.491 22.3968C58.7309 22.9194 59.9442 23.4607 59.9442 24.8233C59.9442 25.9806 58.9362 27.0632 56.9576 27.0632C55.1657 27.0632 53.8405 26.2979 52.7579 25.2153L51.8433 26.3539C53.1312 27.6231 54.7924 28.3884 56.9017 28.3884L56.9017 28.3885Z"
          fill="#71458F"
        />
        <path
          d="M67.1837 27.1385C65.2799 27.1385 63.9546 25.7573 63.7493 23.872H71.6448C71.6448 20.4936 69.9836 18.291 67.0717 18.291C64.4772 18.291 62.312 20.4375 62.312 23.3121C62.312 26.2799 64.6266 28.3891 67.2024 28.3891C68.5463 28.3891 70.2449 27.8105 71.0849 26.8959L70.2262 25.9812C69.6289 26.6345 68.3223 27.1385 67.1837 27.1385L67.1837 27.1385ZM67.1278 19.5416C69.0503 19.5416 70.0769 20.8855 70.2636 22.6214H63.7679C64.0292 20.7549 65.4105 19.5416 67.1278 19.5416H67.1278Z"
          fill="#71458F"
        />
        <path
          d="M77.126 18.291C75.7634 18.291 74.5129 19.0376 73.9529 20.0642V18.515H72.553V28.1651H73.9529V22.0241C73.9529 20.6802 75.3155 19.5416 76.9394 19.5416C78.358 19.5416 79.3473 20.6429 79.3473 22.2108V28.1651H80.7472V22.0241C80.7472 19.8403 79.2539 18.291 77.126 18.291Z"
          fill="#71458F"
        />
        <path
          d="M89.6002 15.1172V20.3249C88.8723 19.0556 87.6403 18.2904 86.0911 18.2904C83.5526 18.2904 81.6487 20.3809 81.6487 23.3301C81.6487 26.2979 83.5526 28.3885 86.0911 28.3885C87.6403 28.3885 88.8723 27.6231 89.6002 26.3539V28.1645H91.0001V15.1172H89.6002ZM86.3524 27.1379C84.4672 27.1379 83.1232 25.5513 83.1232 23.3301C83.1232 21.1088 84.4672 19.5409 86.3524 19.5409C88.2563 19.5409 89.6002 21.1088 89.6002 23.3301C89.6002 25.5513 88.2563 27.1379 86.3524 27.1379Z"
          fill="#71458F"
        />
      </g>
      <defs>
        <clipPath id="clip0_31173_33845">
          <rect width="91" height="28.3881" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
  const imgList = [
    // { img: nnpcImg, delay: "0" },
    { img: zojapayImg, delay: "0" },
    { img: manceImg, delay: "200" },
    { img: swapImg, delay: "400", icon_svg: swapIcon },
  ];

  useEffect(() => {
    Aos.init({
      duration: 1000,
      offset: 0,
    });
  }, []);

  return (
    <div className="trust-section-wrap">
      <div className="size-wrap">
        <p className="title heading-two">Trusted by finance teams</p>
      </div>
      <div className="video-bg">
        <div className="size-wrap">
          {imgList?.map((chi, idx) => {
            return (
              <div
                key={idx}
                data-aos="fade-up"
                data-aos-delay={chi.delay}
                className="img-wrap"
              >
                {chi?.icon_svg ? (
                  <figure className="img-box">{chi?.icon_svg} </figure>
                ) : (
                  <figure className="img-box">
                    <img src={chi?.img} alt="" className="img" />
                  </figure>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* <div className="down-text">The Ultimate Budget Management Solution</div> */}
    </div>
  );
};

export default TrustSection;
